import { render, staticRenderFns } from "./Page_List.vue?vue&type=template&id=22fc2383"
import script from "./Page_List.vue?vue&type=script&lang=js"
export * from "./Page_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports